export const styles = (scroll: boolean) => {
    return {
        position: scroll ? 'fixed' : 'static', top: scroll ? '0px' : '60px', zIndex: '999', backgroundColor: 'white', width: scroll ? '100%' : '', maxHeight: '70px',
    };
};
